import { Injectable, TemplateRef, Type } from '@angular/core';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Pair } from 'src/app/models/pair';
import { Stack } from 'src/app/models/stack';
import { NavigationStackEntry, Options } from './modal.model';

@Injectable({
  providedIn: 'root',
})
export class SbModalState {
  public options: Map<string, Options<any>>;
  public modals: Map<string, NgbModalRef>;
  public templates: Map<string, TemplateRef<any>>;
  public modalOptions: Map<string, NgbModalOptions>;

  public navigationStack: Stack<NavigationStackEntry>;

  public navigationSharedData: any;

  constructor() {
    this.options = new Map();
    this.modals = new Map();
    this.templates = new Map();
    this.modalOptions = new Map();

    this.navigationStack = new Stack();
    this.navigationSharedData = {};
  }
}
